import React from 'react'

const Contact = () => {
  return (
    <div id="contact" className='contact'>
        <h3>That's All About Me, Feel Free<br/> To Say Hi! </h3>
        <p>Catch Up with me, <br/>I am available to work just mail me at working time (8 a.m : 5 p.m) I'm very<br/> welcome for everyone.</p>
        <a href='mailto:mohamedmedhat86452@yahoo.com' className='contact-button'>Contact Me</a>
    </div>
  )
}

export default Contact